<template>
  <!--电价配置-->
  <div class="elePricePage">
    <div class="title">
      <p>
        <span>电价配置</span>
      </p>
    </div>
    <div class="content">
      <!--数据列表内容-->
      <div class="contain">
        <!--搜索-->
        <div class="searchBox">
          <div class="liBox">
            <span>方案名称：</span>
            <el-input v-model="name" clearable placeholder="请输入方案名称"></el-input>
          </div>
          <div class="liBox">
            <el-button type="primary" @click="getListFun">查询</el-button>
          </div>
        </div>
        <!--新增电价配置-->
        <el-button class="addBtn" type="primary" @click="addClick">
          <el-icon>
            <Plus/>
          </el-icon>
          新增电价
        </el-button>
        <!--电价列表-->
        <el-table v-loading="loading" :data="tableData" style="width: 100%">
          <template #empty>
            <el-empty class="emptyClass" description="暂无数据信息"
                      image="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png">
              <p>您可以在此页面新增电价</p>
            </el-empty>
          </template>
          <el-table-column label="方案名称" prop="name"/>
          <el-table-column label="生效日期" prop="startTime"/>
          <el-table-column label="峰谷时段" prop="priceList">
            <template #default="scope">
              <div v-for="(item,index) in scope.row.priceList" :key="index" class="item">
                <p v-if="item.type==1" class="type1 typeBox">尖</p>
                <p v-if="item.type==2" class="type2 typeBox">峰</p>
                <p v-if="item.type==3" class="type3 typeBox">平</p>
                <p v-if="item.type==4" class="type4 typeBox">谷</p>
                <p v-if="item.type==5" class="type5 typeBox">深谷</p>
                <el-input v-model="item.value" disabled>
                  <template #append>元/kwh</template>
                </el-input>
              </div>
              <div v-for="(item,index) in scope.row.ladderList" :key="index" class="item">
                <p class="type6 typeBox">第{{ index + 1 }}档</p>
                <p>{{ item.downValue }}-{{ item.upValue }} kwh &nbsp; +{{ item.value }} 元/kwh</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="inUseFlag">
            <template #default="scope">
              <p :style="{background:scope.row.inUseFlag == 1?'#E8FFEA':'#FEF4E5',color:scope.row.inUseFlag == 1?'#00B42A':'#F78E00'}"
                 class="status">
                {{
                  scope.row.inUseFlag == 1 ? '正在使用' : '等待中'
                }}</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template #default="scope">
              <div class="opacity">
                <span class="btn" @click="editClick(scope.row)">编辑</span>
                <span class="btn" @click="lookEquipmentClick(scope.row.id)">查看设备</span>
                <span v-if="scope.row.canDeleteFlag==1" class="btn delClass" @click="delClick(scope.row.id)">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag">
          <el-pagination v-model:page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :total="total" background
                         layout="total,sizes,prev, pager, next" small @size-change="handleSizeChange"
                         @current-change="pageChange"/>
        </div>
      </div>
    </div>
    <!--新增电价弹窗-->
    <el-dialog v-model="dialogVisible3" :close-on-click-modal="false" class="priceDialog" title="新建" width="80%">
      <div class="dialogCont" style="display: block">
        <div class="timeBox" style="margin-bottom: 16px;">
          <span style="margin-right: 16px;">电价名称</span>
          <el-input v-model="priceFormData.name" placeholder="请输入电价名称"></el-input>
        </div>
        <div class="timeBox" style="margin-bottom: 16px;">
          <span style="margin-right: 16px;">生效日期</span>
          <el-date-picker
              v-model="priceFormData.startTime"
              :disabled-date="disabledDate"
              placeholder="请选择生效时间"
              type="date"
              value-format="YYYY-MM-DD"
          />
        </div>
        <div class="titName">分时计费</div>
        <el-table :data="priceFormData.priceList">
          <el-table-column label="计价类型" min-width="220">
            <template #default="scope">
              <span v-if="scope.row.type==1"
                    style="display: inline-block;padding: 0 4px;border-radius: 3px;background-color: #F21110;color: #fff">尖</span>
              <span v-if="scope.row.type==2"
                    style="display: inline-block;padding: 0 4px;border-radius: 3px;background-color: #F57244;color: #fff">峰</span>
              <span v-if="scope.row.type==3"
                    style="display: inline-block;padding: 0 4px;border-radius: 3px;background-color: #50D5D9;color: #fff">平</span>
              <span v-if="scope.row.type==4"
                    style="display: inline-block;padding: 0 4px;border-radius: 3px;background-color: #3587DA;color: #fff">谷</span>
              <span v-if="scope.row.type==5"
                    style="display: inline-block;padding: 0 4px;border-radius: 3px;background-color: #748EE3;color: #fff">深谷</span>
            </template>
          </el-table-column>
          <el-table-column label="电价" min-width="220">
            <template #default="scope">
              <el-input v-model="scope.row.value" style="width: 180px">
                <template #append>元/kwh</template>
              </el-input>
            </template>
          </el-table-column>
        </el-table>
        <div class="strategyBox strategyBox2">
          <div class="titName" style="margin-top: 16px;">阶梯计费</div>
          <div class="pricingMethod">
            <span>计价方式：</span>
            <el-radio-group v-model="priceFormData.ladderType">
              <el-radio :value="1">按月用量</el-radio>
              <el-radio :value="2">按年用量</el-radio>
            </el-radio-group>
          </div>
          <el-table :data="priceFormData.ladderList" style="width: 100%;margin: 16px 0 ;">
            <el-table-column label="档级" min-width="150">
              <template #default="scope">
                    <span
                        style="display: inline-block;padding: 0 4px;border-radius: 3px;background-color: #A084FA;color: #fff">第{{
                        scope.$index + 1
                      }}档</span>
              </template>
            </el-table-column>
            <el-table-column label="下限（>）" min-width="220">
              <template #default="scope">
                <el-input v-model="scope.row.downValue">
                  <template #append>kwh</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="上限（≤）" min-width="220">
              <template #default="scope">
                <el-input v-model="scope.row.upValue">
                  <template #append>kwh</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="电价浮动" min-width="220">
              <template #default="scope">
                <div style="display: flex;align-items: center">
                  <span style="margin-right: 5px">+</span>
                  <el-input v-model="scope.row.value">
                    <template #append>元/kwh</template>
                  </el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="100">
              <template #default="scope">
                <ul class="operationUl">
                  <li v-if="scope.$index!==0" class="deleteClass" @click="delTime2(scope.$index)">
                    <el-icon>
                      <Delete/>
                    </el-icon>
                  </li>
                  <li class="editClass" @click="addTime2(scope.$index)">
                    <el-icon>
                      <Plus/>
                    </el-icon>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <template #footer>
				<span class="dialog-footer">
		    		<el-button class="resetButton" @click="dialogVisible3 = false">取消</el-button>
		    		<el-button type="primary" @click="addPriceFun">确定</el-button>
      			</span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import './elePrice.less'

import {h, onMounted, ref} from "vue"
import {Plus} from '@element-plus/icons-vue'
import {ElMessage, ElMessageBox} from 'element-plus'
import {useRouter} from 'vue-router';
import qs from "qs";
import {delElePricePlanListApi, getElePricePlanListApi, saveElePricePlanListApi} from "@/api/modules/rate";

let router = useRouter()


// 电价-----------------------------------------------------------------------
// 分页
let pageNumber = ref(1)
let pageSize = ref(20)
let total = ref()
// 更改每页多少
const handleSizeChange = function (e) {
  pageSize.value = e
  getListFun()
}
// 跳转到某页
const pageChange = function (e) {
  pageNumber.value = e
  getListFun()
}
// 电价表格数据
let tableData = ref([])
// 获取电价列表
let name = ref('')
let loading = ref(false)
const getListFun = function () {
  loading.value = true
  getElePricePlanListApi(qs.stringify({
    pageNumber: pageNumber.value,
    pageSize: pageSize.value,
    name: name.value,
  })).then(res => {
    loading.value = false
    if (res.data.code === 0) {
      tableData.value = res.data.result.list
      total.value = Number(res.data.result.total)
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


// 组合包对应电价的处理****************************************************************
// 禁用今天之前的时间
const disabledDate = function (time) {
  return time.getTime() < Date.now() - 8.64e7; // 8.64e7 毫秒数代表一天
}
// 新增电价弹窗
let dialogVisible3 = ref(false)
let priceFormData = ref({
  id: 0,
  startTime: '',
  name: '',
  priceList: [
    {
      type: 1,
      value: ''
    },
    {
      type: 2,
      value: ''
    },
    {
      type: 3,
      value: ''
    },
    {
      type: 4,
      value: ''
    },
    {
      type: 5,
      value: ''
    }
  ],
  ladderType: 1,
  ladderList: [{
    downValue: '',
    upValue: '',
    value: ''
  }]
})
// 点击新增
const addClick = function () {
  dialogVisible3.value = true
  priceFormData.value = {
    id: 0,
    startTime: '',
    name: '',
    priceList: [
      {
        type: 1,
        value: ''
      },
      {
        type: 2,
        value: ''
      },
      {
        type: 3,
        value: ''
      },
      {
        type: 4,
        value: ''
      },
      {
        type: 5,
        value: ''
      }
    ],
    ladderType: 1,
    ladderList: [{
      downValue: '',
      upValue: '',
      value: ''
    }]
  }
}
// 点击编辑
const editClick = function (scope) {
  dialogVisible3.value = true
  priceFormData.value = scope
}
// 添加档级
const addTime2 = function (idx) {
  priceFormData.value.ladderList.splice(idx + 1, 0, {
    downValue: '',
    upValue: '',
    value: '',
  })
  priceFormData.value.ladderList[idx + 1].downValue = priceFormData.value.ladderList[idx].upValue
}
// 删除档级
const delTime2 = function (idx) {
  priceFormData.value.ladderList.splice(idx, 1)
}
// 新增电价提交
const addPriceFun = function () {
  if (priceFormData.value.name && priceFormData.value.startTime) {
    saveElePricePlanListApi(qs.stringify({
      id: priceFormData.value.id,
      name: priceFormData.value.name,
      startTime: priceFormData.value.startTime,
      ladderType: priceFormData.value.ladderType,
      priceJsonStr: JSON.stringify(priceFormData.value.priceList),
      ladderJsonStr: JSON.stringify(priceFormData.value.ladderList),
    })).then(res => {
      if (res.data.code === 0) {
        dialogVisible3.value = false
        getListFun()
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message,
        })
      }
    }).catch(err => {
      console.log(err);
    })

  } else {
    ElMessage({
      type: 'info',
      message: '请填写电价名称和生效日期'
    })
  }
}


// 删除电价
const delClick = function (id) {
  ElMessageBox.confirm('', '', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    title: '删除电价',
    message: h('p', null, [
      h('img', {
        src: 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png',
        style: 'width:20px;height:20px;transform: translateY(4px);margin-right:8px;'
      }, ''),
      h('span', {style: 'color:#595959;'}, '请确认是否要删除此电价，删除后数据不可恢复'),
    ])
  }).then(() => {
    delElePricePlanListApi(qs.stringify({
      id: id
    })).then(res => {
      if (res.data.code === 0) {
        ElMessage({
          type: 'success',
          message: '删除成功',
        })
        getListFun()
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message,
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }).catch(() => {
    ElMessage({
      type: 'info',
      message: '取消删除',
    })
  })
}


// 查看设备
const lookEquipmentClick = function (id) {
  router.push({
    path: '/admin/equipmentDetail',
    query: {
      type: 1,
      id: id
    }
  })
}


onMounted(() => {
  getListFun()
})

</script>

<style lang="less" scoped>
</style>
